module.exports = __webpack_public_path__ + "img/btn_yaoqing@2x.e578165f.png";